/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import {
  Portfolios, Testimonials, Advantages,
} from 'json/landingPageData';

import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Achievement from 'parts/Achievement';
import Portfolio from 'parts/Portfolio';
import Advantage from 'parts/Advantage';
import TeamPreview from 'parts/TeamPreview';
import Testimonial from 'parts/Testimonial';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

// Software-house-specific sections (app categories, tech-stack partner logos)
// were intentionally dropped from the template — see plan section
// "LandingPage simplification".
export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <main id="main">
        <Hero />
        <Achievement />
        <Portfolio data={Portfolios} />
        <Advantage data={Advantages} />
        <TeamPreview />
        <Testimonial data={Testimonials} />
        <Discuss />
        </main>
        <Footer />
      </>
    );
  }
}
